import { jsx } from 'react/jsx-runtime';
import 'react';
import { Box } from '@vp/swan';
import { OrderReplacementFeature } from '../entry/OrderReplacementFeature.js';
import './styles.scss.js';

const EmbeddedContent=()=>{return jsx(Box,{"data-cy":"selfservice-embedded-content-container",className:"embedded-content-container",children:jsx(OrderReplacementFeature,{})})};

export { EmbeddedContent };
//# sourceMappingURL=EmbeddedContent.js.map
